import { ISimilarityCollectionService } from '@src/slide/application/service/similarity-collection/similarity-collection-service.interface';
import { IDynamicServiceConfig } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';

export const similarityCollectionConfig: IDynamicServiceConfig<ISimilarityCollectionService> = {
    name: 'similarity-collection',
    loadType: 'eager',
    async module() {
        let resolveHandler;
        window.similarityCollectionService = new Promise(resolve => resolveHandler = resolve);
        const SimilarityCollection = (await import(/* webpackChunkName: "similarity-service" */ '@src/slide/application/service/similarity-collection')).default;
        const instance = new SimilarityCollection();
        resolveHandler(instance);
        return instance;
    },
};
